export const apiKey = 'cf68c9f5-2900-4a80-a413-8347d137161a';
export const iabVersion = 2;
